import { gql } from '@apollo/client'
import React from 'react'

import { usePlace } from '../../../_load/PlaceLoader'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { placesClient } from '../../../../../../utils/apollo/api'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'
import { useModalData } from '../../../../../../components/modals/ModalsContext'

const Context = React.createContext()
const { Provider } = Context
export const useLocksState = () => React.useContext(Context) || {}
export const useLocks = () => useLocksState()?.locks || []

const QUERY = gql`
  query Locks($filter: LockFilter) {
    locks(filter: $filter) {
      id
      reason
      deleted
      enabled
      nonCompliance {
        id
        place {
          id
          name
          resume
        }
        question {
          id
          name
          category {
            id
            name
          }
          checklist {
            id
            name
          }
        }
        status
        origin
        insertedAt
        updatedAt
        endDate
      }
      checklist {
        id
        name
      }
    }
  }
`

const LocksLoader = ({ children, placeId, checklistId }) => {
  const modalData = useModalData()
  const place = usePlace()

  placeId = placeId || place?.id

  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        placeId,
        ...(checklistId ? { checklistId } : modalData.lock ? { checklistId: modalData.lock.checklistId } : {})
      }
    },
    client: placesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default LocksLoader
